import { Component, OnInit } from '@angular/core';

import { MaintenanceModeService } from '../../shared/maintenance-mode.service';

@Component({
  selector: 'app-maintenance-toggle',
  templateUrl: './maintenance-toggle.component.html',
  styleUrls: ['./maintenance-toggle.component.css']
})
export class MaintenanceToggleComponent implements OnInit {
  active: boolean | null = null;
  adminKey = '';
  loading = true;
  saving = false;
  message = '';
  error = '';

  constructor(private maintenanceMode: MaintenanceModeService) {}

  ngOnInit(): void {
    this.loadState();
  }

  loadState(): void {
    this.loading = true;
    this.error = '';

    this.maintenanceMode.getState().subscribe(
      state => {
        this.active = state.active;
        this.loading = false;
      },
      () => {
        this.error = 'ไม่สามารถอ่านสถานะจากเซิร์ฟเวอร์ได้';
        this.loading = false;
      }
    );
  }

  setMode(active: boolean): void {
    if (!this.adminKey.trim()) {
      this.error = 'กรุณากรอกรหัสผู้ดูแลระบบ';
      return;
    }

    this.saving = true;
    this.error = '';
    this.message = '';

    this.maintenanceMode.setActive(active, this.adminKey).subscribe(
      state => {
        this.active = state.active;
        this.adminKey = '';
        this.message = state.active
          ? 'เปิดโหมดกำลังปรับปรุงแล้ว ทุกเครื่องจะเห็นหน้าปรับปรุง'
          : 'เผยแพร่เว็บไซต์แล้ว ทุกเครื่องสามารถเข้าหน้าปกติได้';
        this.saving = false;
      },
      response => {
        this.error = response.status === 403
          ? 'รหัสผู้ดูแลระบบไม่ถูกต้อง'
          : 'บันทึกสถานะไม่สำเร็จ กรุณาตรวจสอบ PHP และสิทธิ์เขียนไฟล์บนเซิร์ฟเวอร์';
        this.saving = false;
      }
    );
  }
}